import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pop-column-toggle',
  templateUrl: './column-toggle.component.html',
  styleUrls: ['./column-toggle.component.less']
})
export class ColumnToggleComponent {
  @Input() isEnabled = true;

  @Input()
  public tooltipCollapsed?: string;
  @Input()
  public tooltipExpanded?: string;

  @Input()
  public iconClassCollapsed = 'fa-plus-square';
  @Input()
  public iconClassExpanded = 'fa-minus-square';

  private _isCollapsed: boolean | undefined;
  @Input() get isCollapsed() {
    return this._isCollapsed;
  }
  set isCollapsed(value: boolean | undefined) {
    const oldValue = this._isCollapsed;
    this._isCollapsed = value;
    if (oldValue !== value || oldValue !== undefined) {
      this.isCollapsedChange.emit(value);
    }
  }

  @Output() isCollapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public toggle() {
    this.isCollapsed = !this.isCollapsed;
  }
}
